import { CloudResourceEntity } from '@internal/backstage-plugin-catalog-devops-common';

export const filterCloudFields = (entity: CloudResourceEntity) => {
  const tempRecords = entity.spec.cloudFields;
  const filteredKeys = Object.keys(tempRecords).filter(
    key => !(key.includes('UId') || key.includes('Name')),
  );
  const filteredRecords: Record<string, string> = {};
  filteredKeys.forEach(key => {
    const value = tempRecords[key];
    const valueType = typeof value;
    if (
      valueType === 'string' ||
      valueType === 'number' ||
      valueType === 'boolean'
    ) {
      filteredRecords[key] = tempRecords[key].toString();
    }
  });
  return filteredRecords;
};
